<app-local-loading-indicator *ngIf="locationSvc.isLoading$ | async" width="90%" height="100%" applyOverlay="true">
</app-local-loading-indicator>
<app-common-filter [list]="locationList" textField='text' [(filter)]="filter" [(isDirty)]="isDirty"
identifier="shipment_filter_destination" valueField="value">
</app-common-filter>